import { notification } from 'antd'
import { WarningIcon, CloseIcon2 } from 'components/Icons'

const popupError = (error: string, duration?: number) =>
  notification.open({
    message: error,
    icon: <WarningIcon />,
    closeIcon: <CloseIcon2 />,
    className: 'error-popup',
    duration: duration ?? 4.5
  })

export default popupError
